// "Tu escalera hoy" de Metas: dónde va, la curva de lo que puede ganar con cada venta adicional y las
// reglas que no caben en ella. Mockup: `mcEscCard` de portal-vendedor-comisiones.html.
import { cn } from '@/lib/cn';
import { formatMoneyCents } from '@/shared/lib/format/money';
import { plural } from '@/shared/lib/format/plural';
import type { Ladder } from '../lib/ladder';
import { CARD, TITLE } from './cardStyles';
import { LadderChart, LadderLegend } from './LadderChart';

const TAG = 'text-[9.5px] font-bold uppercase tracking-[0.05em] text-muted-foreground';

export function LadderCard({ ladder }: { ladder: Ladder }) {
    const { now, next, leftOut } = ladder;
    const grows = next.some((point) => point.cents !== now.cents);
    return (
        <section className={cn(CARD, 'flex flex-col')} aria-label="Tu escalera hoy">
            <h2 className={TITLE}>
                Tu escalera hoy · lo que puedes ganar con cada venta adicional
            </h2>
            <p className="mb-2.5 flex flex-wrap items-baseline justify-between gap-2 rounded-md bg-muted/30 px-3 py-2 text-[11.5px]">
                <span>
                    <span className={TAG}>Ahora vas en</span>{' '}
                    <b className="text-[14px] tabular-nums">
                        {plural(now.sales, 'venta', 'ventas')}
                    </b>{' '}
                    ({plural(now.units, 'pieza', 'piezas')})
                </span>
                <span>
                    <span className={TAG}>Ganado hasta ahora</span>{' '}
                    <b className="text-[14px] tabular-nums">{formatMoneyCents(now.cents)}</b>
                </span>
            </p>
            {grows ? (
                <div className="flex min-h-0 flex-1 flex-col">
                    <LadderChart ladder={ladder} />
                    <LadderLegend />
                </div>
            ) : (
                <p className="text-[11px] text-muted-foreground">
                    Con las reglas vigentes, más ventas no cambian lo que llevas.
                </p>
            )}
            <p className="mt-1 text-[10.5px] text-muted-foreground">
                Cuenta cada venta adicional como un equipo.
                {leftOut.length > 0 &&
                    ` No entran: ${leftOut.map((rule) => `${rule.name} (${rule.reason})`).join(', ')}.`}
            </p>
        </section>
    );
}
